import {
  calculateLRC,
  commandCode,
  getHexLengthBytes,
  getPayloadLengthBytes,
  toHex,
} from './utils';

const configurePrintingRequest = () => {
  const messageIdentifier = toHex('V2');

  const requestMessage = [];
  requestMessage.push(commandCode.CONFIGURE_PRINTING);
  requestMessage.push('ON');

  const payload = Buffer.from(requestMessage.join());
  const payloadHex = payload.toString('hex');

  const calculatedLRC = calculateLRC(payloadHex);
  const payloadLengthBytes = getPayloadLengthBytes(payload.length);
  const hexLengthBytes = getHexLengthBytes(payloadLengthBytes);
  const buffer = messageIdentifier + hexLengthBytes + payloadHex + calculatedLRC;

  return buffer;
};

export { configurePrintingRequest };
